export enum LayerIds {
  clusterCount = 'cluster-count',
  clusterStars = 'cluster-stars',
  unclusteredPoint = 'unclustered-point',
}

export enum SourceIds {
  photoPoints = 'photo-points',
}
